import type { ErrorResponse } from '../../shared/types'
import type { CustomerEntity, MigrationSuccessResponse } from './entities'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { MigrateCustomerAndPayments, VerifyMigrateCustomerAndPaymentsResponseSchema } from './entities'

const c = initContract()

const options = {
  pathPrefix: '/migration',
}

export const paymentMigrationContract = c.router({
  migrateCustomerAndPayments: {
    method: 'POST',
    description: 'This endpoint will be used during the migration to create a customer and a payment method',
    path: '',
    body: z.object({
      dryRun: z.boolean().default(false),
      customerAndPayments: MigrateCustomerAndPayments,
    }),
    responses: {
      200: c.type<CustomerEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  deleteMigratedCustomerAndPayments: {
    method: 'DELETE',
    description: 'This endpoint will be used during the migration to delete customer, payment and payment methods',
    path: '/:userId',
    pathParams: z.object({
      userId: z.string().uuid(),
    }),
    responses: {
      200: c.type<MigrationSuccessResponse>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  verifyMigratedCustomerAndPayments: {
    method: 'POST',
    description: 'Verify the migrated customer and payments',
    path: '/verify',
    body: z.object({
      userId: z.string().uuid(),
      customerAndPayments: MigrateCustomerAndPayments,
    }),
    responses: {
      200: VerifyMigrateCustomerAndPaymentsResponseSchema,
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
}, options)
